<template>
  <div class="all_part">
    <div class="head">
      <div class="back" @click="back">
        <img src="../assets/main_menu_Phone/back.png" alt="" width="25px" />
      </div>
      <div class="titleAndicon">
        <div class="titleName">
          <span>物料主档</span>
        </div>
        <div class="title_icon" @click="navbarShow">
          <img src="../assets/ProductTablePhone_img/icon.png" alt="" width="30px" />
        </div>
      </div>
    </div>
    <div class="heads" v-if="!PanDuanShou">
      <div
        class="heads_button"

        @click="Second_jiage"
      >
        <span>价格与库存</span>
      </div>
      <div
        class="heads_button"
        @click="Second_ZhuDang"
      >
        <span>IC市场信息</span>
      </div>
      <div
        class="heads_button"
        v-if="user_leave.competitive_products == 1"
        @click="TableInputPhone"
      >
        <span>IC市场情报</span>
      </div>

      <div
        class="heads_button"
        v-if="user_leave.task == 1"
        @click="NeiBuXieTiao"
      >
        <span>内部协调</span>
      </div>
      <div
        class="heads_button"
        v-if="user_leave.financeType == 1"
        @click="FinancePhone"
      >
        <span>应收款与发票</span>
      </div>
    </div>
    <div class="input_button" v-if="PanDuanShous">
      <div class="ss"></div>
      <div class="all_input">
        <div class="all_input_top">
          <div>
            <div class="input">
              <el-select
                v-model="ChanPinDaLei_choice"
                placeholder="请选择产品大类"
                style="width: 180px"
              >
                <el-option
                  v-for="item in ChanPinDaLei_Select"
                  :key="item.value"
                  :label="item.category_big"
                  :value="item.category_big"
                  @change="change('a', ChanPinDaLei_choice)"
                  @click="this.serchChanPinXiaoLei()"
                >
                </el-option>
              </el-select>
            </div>
            <div class="input">
              <el-select
                v-model="CaiZhi_choice"
                placeholder="请选择材质"
                style="width: 180px"
              >
                <el-option
                  v-for="item in CaiZhi_select"
                  :key="item.value"
                  :label="item.material"
                  :value="item.material"
                >
                </el-option>
              </el-select>
            </div>
            <div class="input">
              <el-input
                v-model="newItemNo"
                placeholder="请输入新料号"
                style="width: 180px"
              ></el-input>
            </div>
          </div>
          <div>
            <div class="input">
              <el-select
                v-model="ChanPinXiaoLei_choice"
                placeholder="请选择产品小类"
                style="width: 180px"
              >
                <el-option
                  v-for="item in ChanPinXiaoLei_Select"
                  :key="item.value"
                  :label="item.category_small"
                  :value="item.category_small"
                  @change="change('b', ChanPinXiaoLei_choice)"
                >
                </el-option>
              </el-select>
            </div>

            <div class="input">
              <el-input
                v-model="inquiry_no"
                placeholder="请输入询价单号"
                style="width: 180px"
              ></el-input>
            </div>
          </div>
        </div>
        <!-- <div class="input">
              <el-select
                v-model="CaiLiaoXinXi_Code_Choice"
                placeholder="请选择材料信息代码"
                style="width: 180px"
              >
                <el-option
                  v-for="item in CaiLiaoXinXi_Code_Select"
                  :key="item.value"
                  :label="item.title"
                  :value="item.title"
                >
                </el-option>
              </el-select>
            </div> -->
        <!-- <div class="input">
              <el-select v-model="YingDu_Choice" placeholder="请选择硬度" style="width: 180px">
                <el-option
                    v-for="item in YingDu_Select"
                    :key="item.value"
                    :label="item.hardness"
                    :value="item.hardness"
                >
                </el-option>
              </el-select>
            </div>
            <div class="input">
              <el-input
                  v-model="standard_code"
                  placeholder="请输入标准代码"
                  style="width: 180px"
              ></el-input>
            </div>
            
          </div>
          <div>
          
            <div class="input">
              <el-input
                  v-model="oldMaterialNo"
                  placeholder="请输入旧料号"
                  style="width: 180px"
              ></el-input>
            </div>
            <div class="input">
              <el-input
                  v-model="wire_diameter"
                  placeholder="请输入线径"
                  style="width: 180px"
              ></el-input>
            </div>
            <div class="input">
              <el-input
                  v-model="internal_meridian"
                  placeholder="请输入内径"
                  style="width: 180px"
              ></el-input>
            </div>
            <div class="input">
              <el-select v-model="BiaoZhun_Choice" placeholder="请选择标准" style="width: 180px">
                <el-option
                    v-for="item in BiaoZhun_Select"
                    :key="item.value"
                    :label="item.standard"
                    :value="item.standard"
                >
                </el-option>
              </el-select>
            </div>
            <div class="input">
              <el-select v-model="YanSe_Choice" placeholder="请选择颜色" style="width: 180px">
                <el-option
                    v-for="item in YanSe_Select"
                    :key="item.value"
                    :label="item.color"
                    :value="item.color"
                >
                </el-option>
              </el-select>
            </div> -->

        <div class="submit_button">
          <div class="search_button">
            <el-button
              type="primary"
              @click="serchChanPin"
              style="
                height: 34pt;
                width: 97pt;
                background-image: linear-gradient(to right, #358fe5, #1d6eb9);
              "
              >搜索
            </el-button>
          </div>
          <div class="all_second_button">
            <div class="second_button" @click="clearInput">
              <el-button plain type="primary" style="width: 92px; height: 34pt"
                >重置
              </el-button>
            </div>
            <!--          <div class="second_button">-->
            <!--            <el-button plain type="primary" style="width: 92px; height: 48px "-->
            <!--                       @click="inputShow" >{{ PanDuanShou?'收起':'展开' }}-->
            <!--            </el-button-->
            <!--            >-->
            <!--          </div>-->
          </div>
        </div>
        <div class="ShouQi" @click="inputShow">
          <img src="../assets/ProductTablePhone_img/组 3.png" alt="" />
        </div>
      </div>
    </div>
    <div class="ShouQis" @click="inputShow" v-if="!PanDuanShous">
      <img src="../assets/ProductTablePhone_img/组 3.png" alt="" />
    </div>
    <div class="all_spans">
      <div class="all_key">
        <div v-for="(item, i) in tableData" class="list_div">
          <!--        <p class="list_div_p">-->
          <!--          标准:<span class="list_div_span">{{-->
          <!--            item.standard-->
          <!--          }}</span>-->
          <!--        </p>-->
          <p class="list_div_p">
            旧料号:<span class="list_div_span">{{ item.oldMaterialNo }}</span>
          </p>
          <p class="list_div_p">
            新料号:<span class="list_div_p_span">{{ item.newItemNo }}</span>
          </p>
          <p class="list_div_p">
            描述:<span class="list_div_span">{{ item.oldMaterialNo }}</span>
          </p>
          <p class="list_div_p">
            内径:<span class="list_div_span">{{ item.internal_meridian }}</span>
          </p>
          <p class="list_div_p">
            线径:<span class="list_div_span">{{ item.wire_diameter }}</span>
          </p>
          <p class="list_div_p">
            标准:<span class="list_div_span">{{ item.wire_diameter }}</span>
          </p>
          <p class="list_div_p">
            材质:<span class="list_div_span">{{ item.wire_diameter }}</span>
          </p>
          <p class="list_div_p">
            尺寸描述:<span class="list_div_span">{{
              item.dimension_description
            }}</span>
          </p>
          <p class="list_div_p">
            材质描述:<span class="list_div_span" style="line-height: 16px">{{
              item.material_description
            }}</span>
          </p>

          <p class="list_div_p">
            产品大类:<span class="list_div_span">{{ item.category }}</span>
          </p>
          <p class="list_div_p">
            产品小类:<span class="list_div_span">{{
              item.category_small
            }}</span>
          </p>
          <p class="list_div_p">
            询价单号:<span class="list_div_span">{{ item.inquiry_no }}</span>
          </p>
          <p class="list_div_p">
            平台产品编号:<span class="list_div_span">{{
              item.product_number
            }}</span>
          </p>
          <!--        <p class="list_div_p">-->
          <!--          材质:<span class="list_div_span">{{ item.material }}</span>-->
          <!--        </p>-->
          <!--        <p class="list_div_p">-->
          <!--          硬度:<span class="list_div_span">{{ item.hardness }}</span>-->
          <!--        </p>-->

          <!-- <div class="list_div_divs">
            <div class="list_div_div">
              <p class="list_div_p">
                MOQ:<span class="list_div_span">{{ item.MOQ }}</span>
              </p>
              <p class="list_div_p">
                包装量:<span class="list_div_span">{{
                  item.packing_quantity
                }}</span>
              </p>
              <p class="list_div_p">
                面价:<span class="list_div_span">{{ item.money }}</span>
              </p>
              <p class="list_div_p">
                分包价:<span class="list_div_span">{{
                  item.suggested_price
                }}</span>
              </p>
              <p class="list_div_p">
                工程师/主管:<span class="list_div_span">{{
                  item.executive_director
                }}</span>
              </p>
              <p class="list_div_p">
                客户经理:<span class="list_div_span">{{
                  item.account_manager
                }}</span>
              </p>
              <p class="list_div_p">
                主管/客户经理/销售经理:<span class="list_div_span">{{
                  item.sales_manager
                }}</span>
              </p>
              <p class="list_div_p">
                行业经理:<span class="list_div_span">{{
                  item.industry_manager
                }}</span>
              </p>
            </div>
            <div v-for="item in item.child" class="list_div_div">
              <p class="list_div_p">
                MOQ:<span class="list_div_span">{{ item.MOQ }}</span>
              </p>
              <p class="list_div_p">
                包装量:<span class="list_div_span">{{
                  item.packing_quantity
                }}</span>
              </p>
              <p class="list_div_p">
                面价:<span class="list_div_span">{{ item.money }}</span>
              </p>
              <p class="list_div_p">
                工程师/主管:<span class="list_div_span">{{
                  item.executive_director
                }}</span>
              </p>
              <p class="list_div_p">
                客户经理:<span class="list_div_span">{{
                  item.account_manager
                }}</span>
              </p>
              <p class="list_div_p">
                主管/客户经理/销售经理:<span class="list_div_span">{{
                  item.sales_manager
                }}</span>
              </p>
              <p class="list_div_p">
                行业经理:<span class="list_div_span">{{
                  item.industry_manager
                }}</span>
              </p>
            </div>
          </div> -->
          <!-- <p class="list_div_p">
            建议价:<span class="list_div_span">{{ item.discount }}</span>
          </p> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { httpUrl } from "../components/publics";

export default {
  name: "SrandardMaterialMasterPhone",
  data() {
    return {
      user_leave: {},
      PanDuanShous: true,
      PanDuanShou: true,
      tableData: [],
      newItemNo: "", //新料号
      oldMaterialNo: "", //旧料号
      internal_meridian: "", // 产品内径
      wire_diameter: "", //产品线径
      ChanPinXiaoLei_choice: "", //产品小类选择
      CaiZhi_choice: "", //材质选择   //material
      BiaoZhun_Choice: "", //标准选择
      YingDu_Choice: "", //硬度选择
      standard_code: "", //标准代码
      inquiry_no: "", //询价单号
      CaiLiaoXinXi_Code_Choice: "", //材料信息选择
      ChanPinDaLei_choice: "", // 产品大类选择
      YanSe_Choice: "", //颜色选择
      ChanPinDaLei_Select: [], // 产品大类下拉框
      ChanPinXiaoLei_Select: [], //产品小类下拉框
      CaiZhi_select: [], //材质选择拉下
      BiaoZhun_Select: [], //标准下拉框
      YingDu_Select: [], //硬度下拉框
      CaiLiaoXinXi_Code_Select: [], //材料信息下拉框
      YanSe_Select: [], //颜色下拉框
      page: "",
    };
  },
  watch: {
    ChanPinDaLei_choice(newName, oldName) {
      this.serchChanPinXiaoLei(newName);
    },
    ChanPinXiaoLei_choice() {
      this.serchCaiZhi();
    },
  },
  mounted() {
    this.getUser();
    this.serchChanPinDaLei();
    this.serchBiaoZhun();
    this.serchYingDu();
    this.serchCaiLiaoXinxi();
    this.serchYanSe();
  },
  methods: {
    Second_jiage() {
      this.$router.push("/Main_menuPhone_JiaGeYuKuCun");
    },
    Second_ZhuDang() {
      this.$router.push("/SrandardMaterialMasterPhone");
    },
    TableInputPhone() {
      this.$router.push("/TableInputPhone");
    },
    NeiBuXieTiao() {
      this.$router.push("/missionPhone");
    },

    FinancePhone() {
      this.$router.push("/FinancePhone");
    },
    getUser() {
      this.user_leave = JSON.parse(sessionStorage.getItem("user"));
      console.log(this.user_leave);
    },

    change(params, val) {
      console.log(params);
      if (params == "a" && val != "") {
        this.ChanPinXiaoLei_choice = "";
        this.CaiZhi_choice = "";
      }
    },
    back() {
      this.$router.back();
    },
    clearInput() {
      this.newItemNo = ""; //新料号
      this.oldMaterialNo = ""; //旧料号
      this.internal_meridian = ""; // 产品内径
      this.wire_diameter = ""; //产品线径
      this.ChanPinXiaoLei_choice = ""; //产品小类选择
      this.CaiZhi_choice = ""; //材质选择   //material
      this.BiaoZhun_Choice = ""; //标准选择
      this.YingDu_Choice = ""; //硬度选择
      this.standard_code = ""; //标准代码
      this.inquiry_no = ""; //询价单号
      this.CaiLiaoXinXi_Code_Choice = ""; //材料信息选择
      this.ChanPinDaLei_choice = ""; // 产品大类选择
      this.YanSe_Choice = ""; //颜色选择
    },
    inputShow() {
      if (this.PanDuanShous) {
        this.PanDuanShous = !this.PanDuanShous;
      } else {
        this.PanDuanShous = !this.PanDuanShous;
      }
    },
    navbarShow() {
      if (this.PanDuanShou) {
        this.PanDuanShou = !this.PanDuanShou;
        this.PanDuanShous = !this.PanDuanShous;
      } else {
        this.PanDuanShou = !this.PanDuanShou;
        this.PanDuanShous = !this.PanDuanShous;
      }
    },
    reflash(val) {
      this.page = val;
      this.serchFinanceinfo();
    },
    serchBiaoZhun() {
      this.axios
        .get(httpUrl + `/api/index/standard`)
        .then((response) => {
          if (response.data.code == 200) {
            this.BiaoZhun_Select = response.data.data;
            console.log(this.tableData.data);
          }
          // this.$message("搜索成功");
          console.log("success", response.data);
        })
        .catch((error) => console.log(error, "error"));
    },
    serchYingDu() {
      this.axios
        .get(httpUrl + `/api/index/hardness`)
        .then((response) => {
          if (response.data.code == 200) {
            this.YingDu_Select = response.data.data;
            console.log(this.tableData.data);
          }
          // this.$message("搜索成功");
          console.log("success", response.data);
        })
        .catch((error) => console.log(error, "error"));
    },
    serchCaiLiaoXinxi() {
      this.axios
        .get(httpUrl + `/api/index/material_number`)
        .then((response) => {
          if (response.data.code == 200) {
            this.CaiLiaoXinXi_Code_Select = response.data.data;
            console.log(this.tableData.data);
          }
          // this.$message("搜索成功");
          console.log("success", response.data);
        })
        .catch((error) => console.log(error, "error"));
    },
    serchYanSe() {
      this.axios
        .get(httpUrl + `/api/index/colorOffer`)
        .then((response) => {
          if (response.data.code == 200) {
            this.YanSe_Select = response.data.data;
            console.log(this.tableData.data);
          }
          // this.$message("搜索成功");
          console.log("success", response.data);
        })
        .catch((error) => console.log(error, "error"));
    },
    serchCaiZhi() {
      this.axios
        .get(
          httpUrl +
            `/api/index/standard_material?category_small=${this.ChanPinXiaoLei_choice}`
        )
        .then((response) => {
          if (response.data.code == 200) {
            this.CaiZhi_select = response.data.data;
            console.log(this.tableData.data);
          }
          // this.$message("搜索成功");
          console.log("success", response.data);
        })
        .catch((error) => console.log(error, "error"));
    },
    serchChanPinXiaoLei(val) {
      this.axios
        .get(
          httpUrl + `/api/index/standard_category?category_big=${val}`
        )
        .then((response) => {
          if (response.data.code == 200) {
            this.ChanPinXiaoLei_Select = response.data.data;
            console.log(this.tableData.data);
          }
          // this.$message("搜索成功");
          console.log("success", response.data);
        })
        .catch((error) => console.log(error, "error"));
    },
    serchChanPinDaLei() {
      this.axios
        .get(httpUrl + `/api/index/category`)
        .then((response) => {
          if (response.data.code == 200) {
            this.ChanPinDaLei_Select = response.data.data;
            console.log(this.tableData.data);
          }
          // this.$message("搜索成功");
          console.log("success", response.data);
        })
        .catch((error) => console.log(error, "error"));
    },
    serchChanPin() {
      if (
        this.newItemNo === "" &&
        this.CaiZhi_choice === "" &&
        this.ChanPinXiaoLei_choice === "" &&
        this.ChanPinDaLei_choice === "" &&
        this.inquiry_no === ""
      ) {
        this.$$message("请输入查询条件");
        return;
      }
      let suser_id = JSON.parse(sessionStorage.getItem("user"));
      let selectID = suser_id.id;
      console.log(selectID);
      this.axios
        .get(
          httpUrl +
            `/api/index/master_gear?newItemNo=${this.newItemNo}&material=${this.CaiZhi_choice}&category_small=${this.ChanPinXiaoLei_choice}&category_big=${this.ChanPinDaLei_choice}&inquiry_no=${this.inquiry_no}&page=${this.page}&user_id=${selectID}`
        )
        .then((response) => {
          if (response.data.code == 200) {
            if (response.data.data.length > 100) {
              this.$message(response.data.message);
            } else {
              // response.data.data.map((value, key) => {
              //   if (value.child.length > 0) {
              //     value.child.map((val, num) => {
              //       val["id"] = value.id * 10 + num;
              //     });
              //   }
              // });
              this.tableData = response.data.data.data;
              console.log(this.tableData.oldMaterialNo);
            }
          }
          // this.$message("搜索成功");
          this.$message(response.data.message);
        })
        .catch((error) => console.log(error, "error"));
    },
  },
};
</script>

<style>
</style>


<style scoped>
.heads {
  padding-top: 40px;
  flex-direction: column;
  width: 100%;
  justify-content: space-around;
  display: flex;
  align-items: center;
  height: 300px;
  background-image: url("../assets/main_menu_Phone/bg@3x.png");
  position: fixed;
  z-index: 98;
}

.heads span {
  color: #ffffff;
  font-size: 20px;
  line-height: 20px;
  font-weight: 550;
}
.heads_button {
  border-radius: 4px;
  width: 300px;
  height: 40px;
  display: flex;
  background-color: #008de3;
  align-items: center;
  justify-content: center;
}
.head span {
  color: #ffffff;
  font-size: 20px;
  line-height: 20px;
  font-weight: 550;
}
.list_div_div {
  width: 30%;
  display: flex;
  flex-direction: column;
  margin-right: 10px;
}
.all_part {
  height: 100vh;
  background-color: #f2f2f2;
}

.head {
  width: 100%;
  justify-content: space-between;
  display: flex;
  align-items: center;
  height: 45px;
  background-image: url("../assets/main_menu_Phone/bg@3x.png");
  position: fixed;
  z-index: 99;
}

.head span {
  color: #ffffff;
  font-size: 20px;
  line-height: 20px;
  font-weight: 550;
}
.back img {
  margin-top: 5px;
}
.titleName {
  display: flex;
  justify-content: center;
}

.back {
  margin: 0 5px;
}

.all_input {
  display: flex;
  flex-direction: column;
  padding: 0 5px;
  background-color: #ffffff;
  height: 32%;
}

.all_input_top {
  height: 50%;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin: 10px 0;
}

.all_input_bottom {
  height: 50%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.all_input_top_top {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.all_input_top_bottom {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.all_input_bottom_top {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.all_input_bottom_bottom {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.all_button {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 15px;
  margin-top: 15px;
}

.input {
  margin-bottom: 10px;
}
.all_key {
  display: flex;
  flex-direction: column;
}
.two_spans {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: aqua;
}
.Key {
  width: 48%;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 8pt;
  margin-bottom: 4px;
  justify-content: space-between;
}

.serch {
  width: 60%;
}

.list_div {
  box-sizing: border-box;
  margin-top: 20px;
  background: #ffffff;
  background-image: url("../assets/table_logo.png");
  border-radius: 5px;
  padding: 10px 7px;
  width: 100%;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
}

.submit_button {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 20px;
}

.all_second_button {
  display: flex;
  flex-direction: row;
  margin-left: 10px;
}
.titleAndicon {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.title_icon {
  margin-right: 20px;
}
.sousuoButton {
  position: relative;
}
.sousuo_icon {
  top: 16px;
  left: 16px;
  position: absolute;
}
.ChongZhi {
  position: relative;
}
.icon_chong {
  top: 16px;
  left: 10px;
  position: absolute;
}
.ShouQi {
  margin-bottom: 10px;
}
.ShouQis {
  height: 74px;
  align-items: center;
  display: flex;
  flex-direction: column;

  transform: rotate(180deg);
}
.icon_Shou {
  top: 14px;
  left: 12px;
  position: absolute;
}
.icon_Shous {
  top: 15px;
  left: 12px;
  position: absolute;
  transform: rotate(180deg);
}
.all_spans1 {
  width: 50%;
  display: flex;
  flex-direction: column;
}
.all_spans {
  padding: 0 10px;
}
.titles {
  width: 100%;
  margin-top: 10px;
  display: flex;
}
.ss {
  height: 50px;
}
.XinJiuBianHao {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.second_span {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
}
.double_span {
  justify-content: space-between;
  display: flex;
  flex-direction: row;
  width: 100%;
}

.double_spans {
  width: 48%;
}
.list_div_divs {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.list_div_div {
  width: 30%;
  display: flex;
  flex-direction: column;
  margin-right: 10px;
}
.list_div {
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  margin-top: 15px;
  padding: 6px 14px;
  /* background-image: url(./../assets/img_cx_sylogo@2x.png); */
  background-size: 190px 102px;
}

.list_div_p_span {
  color: #008de3;
}

.list_div_span {
  color: #222222;
}

.list_div_p {
  font-size: 12px;
  line-height: 12px;
  color: #a2a2a2;
  text-align: left;
  margin: 6.5px 0;
}
</style>